export default __webpack_public_path__ + "static/media/check-white.d0df6016.svg";